import { AlertTriangle, CloudOff, Ghost } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

const PAINS = [
  {
    icon: AlertTriangle,
    metric: "$3,000",
    title: "The “He Said, She Said” Claim",
    body: "Customer swears that door scratch wasn't there before. No intake photos, no signed walk-around, no leg to stand on. You eat the respray to protect your reviews — again.",
    testid: "pain-point-1",
  },
  {
    icon: CloudOff,
    metric: "$250/mo",
    title: "The Cloud Software Trap",
    body: "Dealer-grade SaaS charges per seat, per month, forever — for features a 2-bay shop will never touch. Cancel and your own paperwork disappears with the subscription.",
    testid: "pain-point-2",
  },
  {
    icon: Ghost,
    metric: "$900+",
    title: "The Ghosting Client",
    body: "You diagnosed it for free because nothing was signed. They took your findings to a cheaper shop. Uncollected diagnostic time quietly costs a busy shop thousands a year.",
    testid: "pain-point-3",
  },
];

export default function PainPoints() {
  return (
    <section className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead
          overline="Diagnosis // The Expensive Admin Leak"
          title="Your shop bleeds money between the wrenches"
          sub="Not from bad work — from missing paperwork. Every week without signed authorizations and written terms is revenue you'll never invoice."
        />
        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {PAINS.map((p, i) => (
            <Reveal key={p.testid} delay={i * 0.12}>
              <div
                data-testid={p.testid}
                className="h-full border border-slate-400/10 bg-panel p-8 transition-colors duration-200 hover:border-blaze/40"
              >
                <div className="flex items-center justify-between">
                  <p.icon className="w-6 h-6 text-blaze" />
                  <span className="font-mono font-bold tracking-tighter text-3xl text-slate-50">{p.metric}</span>
                </div>
                <h3 className="mt-6 font-display text-xl sm:text-2xl font-bold uppercase tracking-tight text-slate-50">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm text-slate-400 leading-relaxed">{p.body}</p>
                <div className="mt-6 h-1 hazard-stripes opacity-40" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
